export function joinArrayOfStrings(
  list: Array<string | null | undefined>,
  joinChar: string
): string {
  return list.filter((listItem) => typeof listItem === "string").join(joinChar);
}
